import React from "react";
import { Table } from "reactstrap";

const ComparisonTable = ({ data }) => {
    if (!data) return null;
    const { headers, rows, styles } = data;

    return (
        <div className="table-responsive mb-4">
            <Table bordered className="mb-0">
                <thead>
                    <tr>
                        {headers?.map((header, i) => (
                            <th
                                key={i}
                                style={{
                                    backgroundColor: styles?.headerBg || "#2f4a7f",
                                    color: styles?.headerText || "#fff",
                                    fontWeight: "600"
                                }}
                            >
                                {header}
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {rows?.map((row, index) => (
                        <tr key={index}>
                            {/* Aspect Column */}
                            <td
                                style={{
                                    fontWeight: "600",
                                    backgroundColor: styles?.rowBgLeft || "#eef2f7"
                                }}
                            >
                                {row.label}
                            </td>

                            {/* BI Column */}
                            <td
                                style={{
                                    backgroundColor: styles?.rowBgLeft || "#eef2f7"
                                }}
                            >
                                {row.bi}
                            </td>

                            {/* Predictive Column */}
                            <td
                                style={{
                                    backgroundColor: styles?.rowBgRight || "#f6e9ec"
                                }}
                            >
                                {row.pa}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default ComparisonTable;